var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',[(!_vm.user)?_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")]):_vm._e(),(_vm.user)?_c('router-link',{attrs:{"to":"welcome"}},[_vm._v("Welcome")]):_vm._e(),_c('router-link',{attrs:{"to":"about"}},[_vm._v("About")]),(_vm.user)?_c('a',{on:{"click":_vm.signOut}},[_vm._v("Sign Out")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }